import api from './api.config';

// Document APIs
export const documentAPI = {
  uploadDocument: async (panelId, file, data = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });

    const response = await api.post(`/documents/panels/${panelId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  getPanelDocuments: async (panelId) => {
    const response = await api.get(`/documents/panels/${panelId}`);
    return response.data;
  },

  downloadDocument: async (id) => {
    const response = await api.get(`/documents/${id}/download`);
    return response.data;
  },

  getMetadata: async (id) => {
    const response = await api.get(`/documents/${id}/metadata`);
    return response.data;
  },

  deleteDocument: async (id) => {
    const response = await api.delete(`/documents/${id}`);
    return response.data;
  }
};

export default documentAPI;
